import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import GlobalNav from "./components/layout/GlobalNav";
import Footer from "./components/layout/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import StudentDashboard from "./pages/StudentDashboard";
import TeacherDashboard from "./pages/TeacherDashboard";
import Quizzes from "./pages/Quizzes";
import AiTutor from "./pages/AiTutor";
import Login from "./pages/Login";
import ModulePage from "./pages/ModulePage";
import LessonsHub from "./pages/LessonsHub";
import QuizRunner from "./pages/QuizRunner";
import Impressum from "./pages/Impressum";
import Register from "./pages/Register";
import RegisterTeacher from "./pages/RegisterTeacher";
import RegisterStudent from "./pages/RegisterStudent";

import ContentHub from "./pages/teacher/ContentHub";
import ModuleCreator from "./pages/teacher/ModuleCreator";
import LessonCreator from "./pages/teacher/LessonCreator";
import QuizCreator from "./pages/teacher/QuizCreator";
import CreateModule from "./pages/CreateModule";

// LiveQuiz
import { LiveQuizSocketProvider } from "./contexts/LiveQuizSocketContext";
import LiveQuizInvitePopup from "./components/liveQuiz/LiveQuizInvitePopup";
import LiveQuizLobby from "./components/liveQuiz/LiveQuizLobby";
import LiveQuizStudentGame from "./components/liveQuiz/LiveQuizStudentGame";
import LiveQuizHostGame from "./components/liveQuiz/LiveQuizHostGame";
import LiveQuizPage from "./pages/teacher/LiveQuizPage";
import LiveQuizRejoinBanner from "./components/liveQuiz/LiveQuizRejoinBanner";
import LiveQuizHostRejoinBanner from "./components/liveQuiz/LiveQuizHostRejoinBanner";
import AdminBulkUpload from "./pages/AdminBulkUpload";
import AdminDocxImport from "./pages/AdminDocxImport";


function AppContent() {
  const location = useLocation();

  const pagesWithoutSidebar = [
    "/",
    "/login",
    "/register",
    "/register-student",
    "/register-teacher",
    "/admin-9x7k2m",
    "/admin-docx-import",
  ];

  const currentPath = location.pathname.toLowerCase();
  const showGlobalFooter = !pagesWithoutSidebar.includes(currentPath);

  const isQuizPage = currentPath.startsWith("/quiz/");
  const isLiveQuizPage = currentPath.startsWith("/livequiz/");
  const showGlobalNav =
    !isQuizPage &&
    !isLiveQuizPage &&
    !pagesWithoutSidebar.includes(currentPath);

  const hasSidebar = showGlobalNav;

  return (
    <>
      {showGlobalNav && <GlobalNav />}

      <div className={`app-main-wrapper ${hasSidebar ? "with-sidebar" : ""}`}>
        <main className="flex-grow-1">
          <Routes>
            <Route path="/" element={<Home />} />

            {/* Student-only routes */}
            <Route path="/StudentDashboard" element={
              <ProtectedRoute allowedRole="student">
                <StudentDashboard />
              </ProtectedRoute>
            } />

            {/* Teacher-only routes */}
            <Route path="/TeacherDashboard" element={
              <ProtectedRoute allowedRole="teacher">
                <TeacherDashboard />
              </ProtectedRoute>
            } />
            <Route path="/teacher/create-module" element={
              <ProtectedRoute allowedRole="teacher">
                <CreateModule />
              </ProtectedRoute>
            } />
            <Route path="/teacher/livequiz" element={
              <ProtectedRoute allowedRole="teacher">
                <LiveQuizPage />
              </ProtectedRoute>
            } />
            <Route path="/teacher/content" element={
              <ProtectedRoute allowedRole="teacher">
                <ContentHub />
              </ProtectedRoute>
            } />
            <Route path="/teacher/content/module/:moduleId" element={
              <ProtectedRoute allowedRole="teacher">
                <ModuleCreator />
              </ProtectedRoute>
            } />
            <Route path="/teacher/content/lesson/:moduleId/:lessonId" element={
              <ProtectedRoute allowedRole="teacher">
                <LessonCreator />
              </ProtectedRoute>
            } />
            <Route path="/teacher/content/quiz/:moduleId/:lessonId" element={
              <ProtectedRoute allowedRole="teacher">
                <QuizCreator />
              </ProtectedRoute>
            } />

            {/* Public routes */}
            <Route path="/Quizzes" element={<Quizzes />} />
            <Route path="/AiTutor" element={<AiTutor />} />
            <Route path="/register" element={<Register />} />
            <Route path="/register-student" element={<RegisterStudent />} />
            <Route path="/register-teacher" element={<RegisterTeacher />} />
            <Route path="/login" element={<Login />} />
            <Route path="/module/:moduleId" element={<ModulePage />} />
            <Route path="/module/:moduleId/lesson/:lessonId" element={<ModulePage />} />
            <Route path="/Lessons" element={<LessonsHub />} />
            <Route path="/quiz/:moduleId/:lessonId" element={<QuizRunner />} />
            <Route path="/impressum" element={<Impressum />} />

            {/* LiveQuiz Fullscreen Routen (ohne GlobalNav) */}
            <Route path="/livequiz/lobby/:roomCode" element={<LiveQuizLobby />} />
            <Route path="/livequiz/game/:roomCode" element={<LiveQuizStudentGame />} />
            <Route path="/livequiz/host/:roomCode" element={<LiveQuizHostGame />} />

            {/* Hidden admin routes - not linked anywhere */}
            <Route path="/admin-9x7k2m" element={<AdminBulkUpload />} />
            <Route path="/admin-docx-import" element={<AdminDocxImport />} />
          </Routes>
        </main>

        {showGlobalFooter && !isQuizPage && !isLiveQuizPage && <Footer />}
      </div>
    </>
  );
}

export default function App() {
  return (
    <LiveQuizSocketProvider>
      <AppContent />
      <LiveQuizInvitePopup />
      <LiveQuizRejoinBanner />
      <LiveQuizHostRejoinBanner />
    </LiveQuizSocketProvider>
  );
}
